/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { diagnostics } from '@utils/diagnostics';

/**
 * A util function to handle exception object in catch block.
 * The typecheck only allows us to declare as type "any". This utils run pre-check to cast type to Error.
 * It also extracts Axios error message and (optionally) notify Sentry.
 */
export function parseException(exception: any, opts?: { notify: boolean }): { message: string; err: Error } {
  const err = exception instanceof Error ? exception : new Error(exception);
  const message = exception.response?.data?.message || exception.message || 'Unknown error';
  if (opts?.notify) {
    diagnostics.error(err);
  }
  return { message, err };
}
